<template>
    <div class="main-about">
        <div class="describe">
            学习 <a class="link" href="https://vue3js.cn/docs/zh/">Vue.js</a> 时写的练习项目。<br>
            UI库使用 <a class="link" href="http://www.materializecss.cn/">Materialize</a> 。
        </div>
        <div class="divider"/>
        <div class="links">
            <div class="describe">相关链接</div>
            <div class="describe">
                <div class="link">Bilibili: <a class="link" href="https://space.bilibili.com/274945998">https://space.bilibili.com/274945998</a></div>
                <div class="link">Github: <a class="link" href="https://github.com/BHznJNs/civilization-idlegame">https://github.com/BHznJNs/civilization-idlegame</a></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {}
</script>

<style scoped>
    .describe {
        width: 100%;
        color: #424242;
        font-size: 1.2rem
    }
    .divider {
        margin: .6rem 0
    }
    div.link {
        width: 100%
    }
</style>